import { 
  ADD_PROPERTY_REQUEST, 
  ADD_PROPERTY_SUCCESS, 
  ADD_PROPERTY_FAIL, 
  ADD_PROPERTY_RESET,
  GET_APPROVED_PROPERTY_REQUEST,
  GET_APPROVED_PROPERTY_SUCCESS,
  GET_APPROVED_PROPERTY_FAIL,
  GET_APPROVED_PROPERTY_RESET,
  GET_PROPERTY_ID_REQUEST,
	GET_PROPERTY_ID_SUCCESS,
	GET_PROPERTY_ID_FAIL,
  GET_PROPERTY_ID_RESET } from "../constants/propertyConstants";

export const addPropertyReducer = (state = {}, action) => {
  switch (action.type) {
    case ADD_PROPERTY_REQUEST:
      return { loading: true }
    case ADD_PROPERTY_SUCCESS:
      return { loading: false, success: true }
    case ADD_PROPERTY_FAIL:
      return { loading: false, error: action.payload }
    case ADD_PROPERTY_RESET:
      return {}
    default:
      return state
  }
}

export const getApprovedPropertyReducer = (state = { data: {} }, action) => {
  switch (action.type) {
    case GET_APPROVED_PROPERTY_REQUEST:
      return { ...state, loading: true }
    case GET_APPROVED_PROPERTY_SUCCESS:
      return { loading: false, data: action.payload }
    case GET_APPROVED_PROPERTY_FAIL:
      return { loading: false, error: action.payload }
    case GET_APPROVED_PROPERTY_RESET:
      return { data: {} }
    default:
      return state
  }
}

export const getPropertyIDReducer = (state = { data: {} }, action) => {
  switch (action.type) {
    case GET_PROPERTY_ID_REQUEST:
      return { ...state, loading: true }
    case GET_PROPERTY_ID_SUCCESS:
      return { loading: false, data: action.payload }
    case GET_PROPERTY_ID_FAIL:
      return { loading: false, error: action.payload }
    case GET_PROPERTY_ID_RESET:
      return { data: {} }
    default:
      return state
  }
}